import React, { useState, useEffect } from "react";
import "./GenericStyles.css";

const FacultyRegister = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("faculty");
  const [departmentId, setDepartmentId] = useState("");
  const [departments, setDepartments] = useState([]);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchDepartments = async () => {
      setLoading(true);
      try {
        const response = await fetch("http://121.52.154.120:3001/api/departments?page=1&limit=100");
        if (!response.ok) throw new Error("Failed to fetch departments.");
        const { data } = await response.json();
        setDepartments(Array.isArray(data) ? data : []);
      } catch (error) {
        setError("Unable to load departments. Please try again later.");
      } finally {
        setLoading(false);
      }
    };
    fetchDepartments();
  }, []);
  
  const handleRegister = async (event) => {
    event.preventDefault();

    if ((role === "faculty" || role === "admin") && (!username.trim() || !password.trim())) {
      setError("Username and password are required.");
      return;
    }

    if (role === "department" && (!password.trim() || !departmentId)) {
      setError("Please select a department and provide a password.");
      return;
    }

    try {
      const requestBody = {
        password,
        role,
        ...(role === "department" ? { departmentId } : { username }),
      };

      const response = await fetch("http://121.52.154.120:3001/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) throw new Error(await response.text());

      setSuccessMessage("Registration successful.");
      setError("");
      setUsername("");
      setPassword("");
      setRole("faculty");
      setDepartmentId("");
    } catch (error) {
      console.error("Registration error:", error);
      setError("Registration failed: " + error.message);
    }
  };

  return (
    <div className="faculty-register">
      <h2>Register User</h2>
      <form onSubmit={handleRegister}>
        {(role === "faculty" || role === "admin") && (
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        )}
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <div className="role-selection">
          <label>
            <input
              type="radio"
              value="faculty"
              name="role"
              checked={role === "faculty"}
              onChange={(e) => setRole(e.target.value)}
            />
            Faculty
          </label>
          <label>
            <input
              type="radio"
              value="admin"
              name="role"
              checked={role === "admin"}
              onChange={(e) => setRole(e.target.value)}
            />
            Admin
          </label>
          <label>
            <input
              type="radio"
              value="department"
              name="role"
              checked={role === "department"}
              onChange={(e) => setRole(e.target.value)}
            />
            Department
          </label>
        </div>

        {role === "department" && (
          <div className="department-selection">
            <label htmlFor="department-select">Select Department:</label>
            <select
              id="department-select"
              value={departmentId}
              onChange={(e) => setDepartmentId(e.target.value)}
              required
            >
              <option value="">Select a department</option>
              {departments.length > 0 ? (
                departments.map((dept) => (
                  <option key={dept.id} value={dept.id}>
                    {dept.deptname}
                  </option>
                ))
              ) : (
                <option value="">No departments available</option>
              )}
            </select>
          </div>
        )}

        <button type="submit">Register</button>
      </form>

      {error && <p className="error-message">{error}</p>}
      {successMessage && <p className="success-message">{successMessage}</p>}
    </div>
  );
};

export default FacultyRegister;
